import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faAngleDown, faAngleLeft, faAngleRight, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faChrome, faFirefox, faSafari } from '@fortawesome/free-brands-svg-icons';

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.mixin({
  computed: {
    $icons() {
      return {
        back: faAngleLeft,
        chrome: faChrome,
        continue: faAngleRight,
        firefox: faFirefox,
        passwordHidden: faEyeSlash,
        passwordVisible: faEye,
        safari: faSafari,
        selectIndicator: faAngleDown,
        spinner: faSpinner,
      };
    },
  },
});
